const performanceTrims = ['st', 'rs', 'shelby gt500', 'svt raptor'];

/**
 * Returns the Dealer Connection specified performance value given a trim.
 *
 * @param {string} trim The vehicle trim
 * @returns {string} The performance value
 */
export default (trim) =>
	typeof trim === 'string' &&
	performanceTrims.indexOf(trim.toLowerCase()) > -1
		? 'performance'
		: 'none';
